import { render, staticRenderFns } from "./testDia.vue?vue&type=template&id=7f78ea3d&scoped=true&"
import script from "./testDia.vue?vue&type=script&lang=js&"
export * from "./testDia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f78ea3d",
  null
  
)

export default component.exports